import FormJaivana from 'dashboard_jaivana_v1';

/**
 *
 * @author Juan Camilo Villa
 * @modified 07-01-2025
*/

/**
 * CustomVendingMaquinasDispensaciones
**/
class CustomVendingMaquinasDispensaciones extends FormJaivana.form {


   constructor(props) {

        super(props);
        this.initForm                                                       = this.initForm.bind(this);
        this.validarCampoFechaFinal                                         = this.validarCampoFechaFinal.bind(this);
        this.validarCampos                                                  = this.validarCampos.bind(this);
        this.newGettDispensationsPage                                       = this.newGettDispensationsPage.bind(this);
        this.successGetNewDispensations                                     = this.successGetNewDispensations.bind(this);
        this.mostrarMensajeGenerando                                        = this.mostrarMensajeGenerando.bind(this);
        this.gridOptionsTbPrincipal                                         = Object.assign({},this.gridOptions);
        this.arrayPrincipal                                                 = [];
        this.countTotal                                                     = 0;
        this.onBtNext2                                                      = this.onBtNext2.bind(this);
        this.onBtPrevius2                                                   = this.onBtPrevius2.bind(this);
        this.onKeyUpText                                                    = this.onKeyUpText.bind(this);
       
    }

    initForm() {
        console.log('CustomVendingMaquinasDispensaciones,  @version: jdesk_1.01.0001, @author: Juan Camilo Villa');    
        this.getField("serial_vending_maquinas").setDisabled(true);
        this.getField("descripcion_vending_maquinas").setDisabled(true);
        this.getField('dateTo').setOnChange(this.validarCampoFechaFinal);
        this.getField('dateFrom').setOnChange(this.validarCampos);
        this.getField('btn_dispensaciones').setClick(this.newGettDispensationsPage);
        
        this.getField('buscador_vending_maquinas').setOnChange(()=>{
            if (this.getField('descripcion_vending_maquinas').getValue() === '' || this.getField('descripcion_vending_maquinas').getValue() === ' ') {
                this.gridOptionsTbPrincipal['rowData'] = [];
                this.getField('tabla_dispensaciones').toggle(false);
            }
        });
        
        this.getField('tabla_dispensaciones').setOnBtnNext(this.onBtNext2);
        this.getField('tabla_dispensaciones').setOnBtnPrevius(this.onBtPrevius2);
        this.getField('tabla_dispensaciones').setKeyUpText(this.onKeyUpText)
    }

    onBtNext2(){
        this.countTotal++;
        this.getField("tabla_dispensaciones").disabledButtons(true);
        this.newGettDispensationsPage();
    }

    onBtPrevius2(){
        this.countTotal--;
        this.getField("tabla_dispensaciones").disabledButtons(true);
        this.newGettDispensationsPage();
    }

    onKeyUpText(value){
        this.countTotal = value;
        this.getField("tabla_dispensaciones").disabledButtons(true);
        this.newGettDispensationsPage();
    }



    validarCampoFechaFinal(){
        this.getField('tabla_dispensaciones').toggle(false);         
        if(Date.parse(this.getField("dateTo").getValue()) >= Date.parse(this.getField("dateFrom").getValue())){
            this.getField('dateTo').setError(false,'');
            this.getField('dateFrom').setError(false,'');
            this.getField('btn_dispensaciones').setDisabled(false);
        }else{
            this.getField('dateTo').setError(true,'* La fecha final no puede ser menor a la fecha inicial');
            this.getField('btn_dispensaciones').setDisabled(true);
        }
    }


    validarCampos(){
        this.getField('tabla_dispensaciones').toggle(false);
        if(Date.parse(this.getField("dateTo").getValue()) >= Date.parse(this.getField("dateFrom").getValue())){
            this.getField('dateTo').setError(false,'');
            this.getField('dateFrom').setError(false,'');
            this.getField('btn_dispensaciones').setDisabled(false);
        }else{
            this.getField('dateFrom').setError(true,'* La fecha inicial no puede ser mayor a la fecha final');
            this.getField('btn_dispensaciones').setDisabled(true);
        }
    }

    
    newGettDispensationsPage(){
        if(Date.parse(this.getField("dateTo").getValue()) < Date.parse(this.getField("dateFrom").getValue())){
            this.getField('dateTo').setError(true,'* La fecha final no puede ser menor a la fecha inicial');
        }else {
            if (this.getField("serial_vending_maquinas").valid()  && this.getField("descripcion_vending_maquinas").valid()){
                this.mostrarMensajeGenerando();
                this.arrayPrincipal = [];
                this.gridOptionsTbPrincipal['rowData'] = [];
                let startDate = this.getField('dateFrom').getValue() + 'T00:00:00-05:00';
                let endDate = this.getField('dateTo').getValue() + 'T23:59:20-05:00';
                


                let datos={ datos: {
                    nit: '',
                    dateFrom: startDate,
                    dateTo: endDate,
                    pageNumber: this.countTotal,
                    scDependencyId: this.getField("sc_dependency_id_vending_maquinas").getValue(),
                }};
                    
                this.generalFormatPmv = { tipo_servicio: 'inte-dispensaciones', operacion: 'getNewDispensationsPage', operacion_tipo: 'consulta' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successGetNewDispensations,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }
        }
    }

    successGetNewDispensations(data){
        this.getField('confirmModalCustom').toggle(false);
        this.getField("tabla_dispensaciones").disabledButtons(false);

        if (data.estado_p === 200) {        
            this.tamdata = data.data[data.data.length-1].datapaginas;  
            this.arrayTbPrincipal = data.data.pop();
            this.getField('dateFrom').setError(false,'');
            this.getField('dateTo').setError(false,'');            

            this.getField('tabla_dispensaciones').setTtotalPg(Math.ceil(this.tamdata));
            this.getField('tabla_dispensaciones').toggle(true);
            this.gridOptionsTbPrincipal['rowData'] = data.data;
            this.getField('tabla_dispensaciones').initData(this.gridOptionsTbPrincipal);
        }else{
            this.mostrarMensajeAdicional('No hay datos.');
            this.gridOptionsTbPrincipal['rowData'] = [];
            this.getField('tabla_dispensaciones').toggle(false);
        }
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => {
        
        });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }
}

FormJaivana.addController('inte-dispensaciones',CustomVendingMaquinasDispensaciones);
export default CustomVendingMaquinasDispensaciones;